/**
 * @fileoverview POST handler for the "/apps/app_groups/:app_group_id/rename" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupsAppGroupIdRenameCacheKeys } from "./constants";
import type { PostAppsAppGroupsAppGroupIdRenameProps } from "./types";

export const postAppsAppGroupsAppGroupIdRename = reactQueryMutationAdapter(
  appsAppGroupsAppGroupIdRenameCacheKeys,
  ({ appGroupId, newName }: PostAppsAppGroupsAppGroupIdRenameProps): Promise<void> => {
    // manipulate props here as needed {  }

    return fetch(`/apps/app_groups/${appGroupId}/rename`, "POST", { name: newName });
  }
);
